import type { ItemEventData } from '@shared/analytics/types/events'
import type { CartLine } from '@shared/shop-api/cart/lines/types'
import type { Cart } from '@shared/shop-api/cart/types'
import type { ProductWithVariants } from '@shared/shop-api/product/types'

export const mapCartLine = (cartLine: CartLine) => {
  return {
    item_id: cartLine.variant.sku,
    item_brand: cartLine.variant.product.attributes.brand,
    price: cartLine.cost.totalAmount,
    item_name: String(cartLine.variant.product.attributes.modelUntranslated),
    item_variant: String(cartLine.variant.product.attributes.styleUntranslated),
    dimension_10: cartLine.variant.size,
    quantity: cartLine.quantity,
  }
}

export const mapCartLines = (cart: Cart) =>
  cart.lines?.map((line) => mapCartLine(line)) || []

export const mapTransactionProducts = (cartLines: CartLine[]) =>
  cartLines.map((cartLine) => ({
    id: cartLine.variant.sku,
    name: String(cartLine.variant.product.attributes.nameUntranslated),
    price: cartLine.cost.totalAmount,
    priceexcludingtax: null,
    quantity: cartLine.quantity,
    sku: cartLine.variant.sku,
    tax: null,
    taxrate: null,
  }))

export const mapWishlistItem = (wishlistItem: ProductWithVariants) => ({
  item_id: wishlistItem.variants[0].sku,
  item_brand: wishlistItem.attributes.brand,
  price: wishlistItem.variants[0].price,
  item_name: String(wishlistItem.attributes.modelUntranslated),
  item_variant: String(wishlistItem.attributes.styleUntranslated),
  dimension_10: wishlistItem.variants[0].size,
  quantity: 1,
})

export const mapProductItem = (options: ItemEventData) => ({
  item_id: options.sku,
  item_brand: options.brand,
  price: options.price,
  item_name: String(options.modelUntranslated),
  item_variant: String(options.styleUntranslated),
  dimension_10: options.size,
})
